type Noop = () => void;

/**
 * The identity function
 */
export const identity = <T>(x: T): T => x;

/**
 * A function that performs a no-op
 */
export const noop: Noop = () => { };

/**
 * A function that always returns null
 */
export const functionThatReturnsNull = () => null;

/**
 * A function that always returns false
 */
export const functionThatReturnsFalse = () => false;

// Enforce private typing so that all DateStrings will have come from this file
enum IsDateString { }
export type DateString = (string & IsDateString) | null;